import { FC } from "react";
import { useSelector } from "src/store/Store";
import { Link } from "react-router-dom";
import LogoLight from "src/assets/images/logo2.png";
import LogoLightRTL from "src/assets/images/favicon.png";
import { styled } from "@mui/material";
import { AppState } from "src/store/Store";

const Logo: FC = () => {
  const customizer = useSelector((state: AppState) => state.customizer);
  const LinkStyled = styled(Link)(() => ({
    height: customizer.TopbarHeight,
    width: customizer.isCollapse ? "40px" : "180px",
    overflow: "hidden",
    display: "block"
  }));

  if (customizer.activeDir === "ltr") {
    return (
      <LinkStyled to="/">
        <img src={LogoLight} height={customizer.TopbarHeight} alt="" className="mt-5"/>
      </LinkStyled>
    );
  }

  return (
    <LinkStyled to="/">
      <img src={LogoLightRTL} height={customizer.TopbarHeight} alt="" />
    </LinkStyled>
  );
};

export default Logo;
